export const establishmentTypesEnum = {
  BRANCH_OR_AGENCY: { value: 1, label: 'Sucursal / Agencia' },
  HEADQUARTERS: { value: 2, label: 'Casa matriz' },
  WAREHOUSE: { value: 3, label: 'Bodega' },
  PROPERTY_OR_YARD: { value: 4, label: 'Predio y/o patio' },
  OTHER: { value: 5, label: 'Otro' },
}

export const establishmentTypes = Object.values(establishmentTypesEnum)
